module.exports = __webpack_public_path__ + "img/Patent_5.d5a78ab8.png";